import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ShortageChangelogService {
  private apiUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_CHANGELOG}`;

  constructor(private http: HttpClient) { }

  getChangelogData(payload: any): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }
}
